const ACCESS_TOKEN_KEY = "ultra_admin_access_token";
const REFRESH_TOKEN_KEY = "ultra_admin_refresh_token";
const ADMIN_USER_KEY = "ultra_admin_user";
const LEGACY_LOGGED_IN_KEY = "ultra_admin_logged_in";

export interface AdminSessionUser {
  id?: number;
  email: string;
  role: "admin";
}

export const getAccessToken = (): string | null =>
  localStorage.getItem(ACCESS_TOKEN_KEY);

export const getRefreshToken = (): string | null =>
  localStorage.getItem(REFRESH_TOKEN_KEY);

export const isAdminLoggedIn = (): boolean => Boolean(getAccessToken());

export const getAdminUser = (): AdminSessionUser | null => {
  const raw = localStorage.getItem(ADMIN_USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as AdminSessionUser;
  } catch {
    return null;
  }
};

export const saveAdminSession = (
  user: AdminSessionUser,
  accessToken: string,
  refreshToken: string
): void => {
  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
  localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  localStorage.setItem(ADMIN_USER_KEY, JSON.stringify(user));
  localStorage.removeItem(LEGACY_LOGGED_IN_KEY);
};

export const updateAdminTokens = (
  accessToken: string,
  refreshToken?: string
): void => {
  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
  if (refreshToken) {
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  }
};

export const clearAdminSession = (): void => {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(ADMIN_USER_KEY);
  localStorage.removeItem(LEGACY_LOGGED_IN_KEY);
};
